/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/11
 */
import React from 'react';

const BackupData = () => {
  return <svg viewBox="0 0 1024 1024" className="store-svg-backupdata">
    <path d="M755.2 627.2H460.8V256h294.4v371.2z m-268.8-25.6h243.2V281.6H486.4v320z" />
    <path d="M409.6 371.2h204.8v307.2H409.6z" fill="#FFFFFF" p-id="1140"/>
    <path d="M576 780.8H281.6V409.6h294.4v371.2z m-268.8-25.6h243.2V435.2H307.2v320z"/>
    <path d="M512 1024C229.12 1024 0 794.88 0 512S229.12 0 512 0 1024 229.12 1024 512 794.88 1024 512 1024z m0-998.4C243.2 25.6 25.6 243.2 25.6 512s217.6 486.4 486.4 486.4 486.4-217.6 486.4-486.4S780.8 25.6 512 25.6z"/>
  </svg>
};

export default BackupData;



// WEBPACK FOOTER //
// ./src/svgs/backupData.js